import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  faChevronLeft,
  faChevronRight,
  faCopy,
  faPrint,
  faReceipt,
  faShare,
} from '@fortawesome/free-solid-svg-icons'
import {
  unSendInvoice,
  updateInvoiceInfo,
} from 'client/utils/api-routes-invoice'
import moment from 'moment'
import {
  ButtonsGroup,
  DcButton,
  PixelDropDownMenu,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  PixelText,
  PixelTooltip,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'

import { createCustomerInvoice, post } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const ActionMenu = (props) => {
  const {
    invoiceId,
    newInvoiceData,
    invoiceData,
    invoiceMeta,
    setInvoiceData,
    setSaveLineItems,
    setShowEmailPopup,
    setShowPaymentModel,
    setShowStripePaymentModel,
    setShowPaymentHistoryModel,
    handleAddNewInvoice,
    isCustomerAdded,
    customerId,
    getPaymentURL,
    getPaymentSafepayURL,
    setInvoiceId,
  } = props

  const {
    showFailure,
    showSuccess,
    showPageLoader,
    hidePageLoader,
    pixelConfirm,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const navigate = useNavigate()

  const markInvoiceUnsent = (invoiceId: number) => {
    showPageLoader()
    unSendInvoice(invoiceId).subscribe((res) => {
      if (
        res.response?.data === true ||
        res.response?.data === null ||
        res.response?.data === 0
      ) {
        hidePageLoader()
        showSuccess('Invoice Status Updated')
        setInvoiceData((prevData) => ({
          ...prevData,
          invoice_sent: res.response?.data,
        }))
      } else {
        hidePageLoader()
        showFailure('Something went Wrong')
      }
    })
  }

  const updateInvoiceStatus = (invoiceId: number, invoiceStatus: string) => {
    showPageLoader()
    const payload = {
      status: invoiceStatus,
    }
    updateInvoiceInfo(invoiceId, payload).subscribe((res) => {
      if (res.response?.data) {
        hidePageLoader()
        showSuccess('Invoice Status Updated')
        setInvoiceData((prevData) => ({
          ...prevData,
          invoice_status: res.response?.data?.invoice_status,
        }))
      } else {
        hidePageLoader()
        showFailure('Something went Wrong')
      }
    })
  }

  const InvoiceSentOptions = [
    {
      label: 'Send via email',
      disabled: false,
      clickHandler: () => {
        setShowEmailPopup(true)
      },
    },
    {
      label:
        invoiceData && invoiceData.invoice_sent
          ? 'Mark Invoice Unsent'
          : 'Mark Invoice Sent',
      disabled: false,
      clickHandler: () => {
        markInvoiceUnsent(invoiceId)
      },
    },
  ]

  const InvoiceStatus = [
    {
      label:
        invoiceData && invoiceData.invoice_status === 'open'
          ? 'Close invoice'
          : 'Re open',
      disabled: false,
      clickHandler: () => {
        if (
          invoiceData?.invoice_status === 'open' &&
          invoiceData?.invoice_payment_status !== 'paid'
        ) {
          showFailure('The invoice cannot be closed untill Payment Due is Paid')
        } else {
          const InvoiceStatusIs =
            invoiceData?.invoice_status === 'open' ? 'closed' : 'open'
          updateInvoiceStatus(invoiceId, InvoiceStatusIs)
        }
      },
    },
  ]

  const paymentsOptions = [
    {
      label: 'Send Payment link Via Stripe',
      clickHandler: () => getPaymentLink(),
    },
    {
      label: 'Send Payment link Via Safepay',
      clickHandler: () => getPaymentLinkViaSafepay(),
    },
    {
      label: 'Record manually',
      clickHandler: () => {
        setShowPaymentModel(true)
      },
    },
    {
      label: 'Pay via Stripe',
      clickHandler: () => {
        setShowStripePaymentModel(true)
      },
    },
    {
      label: 'View Payments',
      clickHandler: () => {
        setShowPaymentHistoryModel(true)
      },
    },
  ]

  const getPaymentLink = () => {
    showPageLoader()
    if (invoiceId && customerId) {
      post(
        `/invoice/${invoiceId}/send-invoice-for-payment/${customerId}`,
        undefined,
      ).subscribe((res) => {
        if (res.response?.data?.id && res.response?.data?.hosted_invoice_url) {
          hidePageLoader()
          showSuccess('Invoice Payment Link Generated Successfully')
          getPaymentURL(res.response?.data?.hosted_invoice_url)
        } else {
          hidePageLoader()
          showFailure(res?.response?.error ?? 'Something went wrong')
        }
      })
    }
  }

  const getPaymentLinkViaSafepay = () => {
    showPageLoader()
    if (invoiceId && customerId) {
      post(
        `/invoice/${invoiceId}/send-invoice-for-payment-via-safepay/${customerId}`,
        undefined,
      ).subscribe((res) => {
        if (res.response?.data) {
          hidePageLoader()
          showSuccess('Invoice Payment Link Generated Successfully')
          getPaymentSafepayURL(
            res.response?.data ??
              res.response?.data?.data[0]?.metadata[0]?.recipient_view_url,
          )
        } else {
          hidePageLoader()
          showFailure(res?.response?.error ?? 'Something went wrong')
        }
      })
    }
  }

  const duplicateInvoice = () => {
    pixelConfirm({
      title: 'duplicate invoice',
      message: 'You are going to create a duplicate invoice!',
      onConfirm: () => {
        showPageLoader()
        const invoiceDataObject = {
          ...invoiceData,

          reference_number: invoiceData.reference_number,
          email: invoiceData.billing?.email,
          due_date: moment().format('DD-MM-YYYY'),
          shipping_address_id: invoiceData.shipping_address.address_id,
          billing_address_id: invoiceData.billing_address.address_id,
          invoice_date: moment().format('DD-MM-YYYY'),
          total_tax: 0,
          line_items: invoiceData.line_items.map((item) => {
            return {
              ...item,
              line_item_id: null,
            }
          }),
        }

        createCustomerInvoice(invoiceDataObject).subscribe(
          (res: AjaxResponse<any>) => {
            hidePageLoader()
            if (res.response?.invoice_id) {
              showSuccess('Invoice Created.')
              navigate(`/invoice/detail/${res.response.invoice_id}`)
            } else {
              showFailure(`${res.response.field} is required`)
            }
          },
        )
      },
    })
  }
  return (
    <>
      {invoiceId === 'new' && (
        <>
          <PixelTooltip
            tooltipText={
              isCustomerAdded
                ? 'Print Invoice'
                : 'Please select a customer to print invoice'
            }
          >
            <DcButton
              disabled={newInvoiceData.customer_id === ''}
              variant="outline-primary"
              margin="0px 10px 0 0"
              size="sm"
              onClick={() => handleAddNewInvoice('print')}
            >
              <PixelFlexBox gap="5px">
                <PixelIcon
                  color="inherit"
                  style={{ margin: '2 0 0 0' }}
                  icon={faPrint}
                />
                <PixelText style={{ display: 'inline-block' }}>Print</PixelText>
              </PixelFlexBox>
            </DcButton>
          </PixelTooltip>
          <PixelTooltip
            tooltipText={
              isCustomerAdded
                ? 'Create Invoice'
                : ' Please select a customer to create an invoice'
            }
          >
            <DcButton
              disabled={newInvoiceData.customer_id === ''}
              onClick={() => {
                handleAddNewInvoice('newInvoice')
              }}
              size="sm"
            >
              Save
            </DcButton>
          </PixelTooltip>
        </>
      )}

      {invoiceId !== 'new' && (
        <>
          <DcButton
            variant="outline-primary"
            size="sm"
            onClick={duplicateInvoice}
          >
            <PixelFlexBox gap="5px">
              <PixelIcon
                color="inherit"
                style={{ margin: '2 0 0 0' }}
                icon={faCopy}
              />
              <PixelText style={{ display: 'inline-block' }}>
                Duplicate
              </PixelText>
            </PixelFlexBox>
          </DcButton>
          <DcButton
            variant="outline-primary"
            margin="0px 0 0 0"
            size="sm"
            onClick={() => {
              setSaveLineItems('savetoPrint')
            }}
          >
            <PixelFlexBox gap="5px">
              <PixelIcon
                color="inherit"
                style={{ margin: '2 0 0 0' }}
                icon={faPrint}
              />
              <PixelText style={{ display: 'inline-block' }}>Print</PixelText>
            </PixelFlexBox>
          </DcButton>
          <PixelDropDownMenu
            variant={'outline-primary'}
            size="sm"
            options={paymentsOptions}
            toggleText={
              <>
                <PixelIcon
                  color="inherit"
                  style={{ marginRight: '5px' }}
                  icon={faReceipt}
                />
                Payments
              </>
            }
          />
          <PixelDropDownMenu
            variant={'outline-primary'}
            size="sm"
            options={InvoiceSentOptions}
            toggleText={
              <>
                <PixelIcon
                  color="inherit"
                  style={{ marginRight: '5px' }}
                  icon={faShare}
                />
                {invoiceData && invoiceData.invoice_sent
                  ? 'Invoice Sent'
                  : 'Send Invoice'}
              </>
            }
          />
          <PixelDropDownMenu
            variant={'outline-primary'}
            size="sm"
            options={InvoiceStatus}
            toggleText={
              invoiceData && invoiceData.invoice_status === 'open'
                ? 'Invoice Status: Open'
                : 'Invoice Closed'
            }
          />
          <ButtonsGroup
            style={{
              gap: '15px',
              alignItems: 'center',
              flexDirection: 'row',
            }}
          >
            <PixelTooltip tooltipText="Previous">
              <DcButton
                disabled={invoiceMeta.previous === null}
                onClick={() => {
                  setSaveLineItems('closeToPagination')
                  setInvoiceId(invoiceMeta.previous)
                }}
                size="sm"
                variant="outline-primary"
              >
                <PixelIcon color="inherit" icon={faChevronLeft} />
              </DcButton>
            </PixelTooltip>
            <PixelText textSize="12px">
              {invoiceMeta.current}/{invoiceMeta.total}
            </PixelText>
            <PixelTooltip tooltipText="Next">
              <DcButton
                disabled={invoiceMeta.next === null}
                onClick={() => {
                  setSaveLineItems('closeToPagination')
                  setInvoiceId(invoiceMeta.next)
                }}
                size="sm"
                variant="outline-primary"
              >
                <PixelIcon
                  color="inherit"
                  fontSize={'14px'}
                  icon={faChevronRight}
                />
              </DcButton>
            </PixelTooltip>
          </ButtonsGroup>
        </>
      )}
    </>
  )
}

export default ActionMenu
